function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { EventDispatcher } from "./EventDispatcher";
import * as $array from "./Array";
/**
 * Checks if specific index fits into length.
 *
 * @param index  Index
 * @param len    Length
 * @ignore
 */
function checkBounds(index, len) {
  if (!(index >= 0 && index < len)) {
    throw new Error("Index out of bounds: " + index);
  }
}
/**
 * A List class is used to hold a number of indexed items of the same type.
 */
export var List = /*#__PURE__*/function (_Symbol$iterator) {
  /**
   * Constructor
   *
   * @param initial  Inital list of values to add to list
   */
  function List() {
    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, List);
    /**
     * List values.
     */
    Object.defineProperty(this, "_values", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new EventDispatcher()
    });
    this._values = initial;
  }
  /**
   * An array of values in the list.
   *
   * Do not use this property to add values. Rather use dedicated methods, like
   * `push()`, `removeIndex()`, etc.
   *
   * @readonly
   * @return List values
   */
  _createClass(List, [{
    key: "values",
    get: function get() {
      return this._values;
    }
    /**
     * Checks if list contains specific item reference.
     *
     * @param item  Item to search for
     * @return `true` if found, `false` if not found
     */
  }, {
    key: "contains",
    value: function contains(value) {
      return this._values.indexOf(value) !== -1;
    }
    /**
     * Removes specific item from the list.
     *
     * @param item An item to remove
     */
  }, {
    key: "removeValue",
    value: function removeValue(value) {
      var i = 0;
      var length = this._values.length;
      while (i < length) {
        // TODO handle NaN
        if (this._values[i] === value) {
          this.removeIndex(i);
          --length;
        } else {
          ++i;
        }
      }
    }
    /**
     * Searches the list for specific item and returns its index.
     *
     * @param item  An item to search for
     * @return Index or -1 if not found
     */
  }, {
    key: "indexOf",
    value: function indexOf(value) {
      return $array.indexOf(this._values, value);
    }
    /**
     * Number of items in list.
     *
     * @readonly
     * @return Number of items
     */
  }, {
    key: "length",
    get: function get() {
      return this._values.length;
    }
    /**
     * Checks if there's a value at specific index.
     *
     * @param index  Index
     * @return Value exists?
     */
  }, {
    key: "hasIndex",
    value: function hasIndex(index) {
      return index >= 0 && index < this._values.length;
    }
    /**
     * Returns an item at specified index.
     *
     * @param index  Index
     * @return List item
     */
  }, {
    key: "getIndex",
    value: function getIndex(index) {
      return this._values[index];
    }
  }, {
    key: "_onPush",
    value: function _onPush(newValue) {
      if (this.events.isEnabled("push")) {
        this.events.dispatch("push", {
          type: "push",
          target: this,
          newValue: newValue
        });
      }
    }
  }, {
    key: "_onInsertIndex",
    value: function _onInsertIndex(index, newValue) {
      if (this.events.isEnabled("insertIndex")) {
        this.events.dispatch("insertIndex", {
          type: "insertIndex",
          target: this,
          index: index,
          newValue: newValue
        });
      }
    }
  }, {
    key: "_onSetIndex",
    value: function _onSetIndex(index, oldValue, newValue) {
      if (this.events.isEnabled("setIndex")) {
        this.events.dispatch("setIndex", {
          type: "setIndex",
          target: this,
          index: index,
          oldValue: oldValue,
          newValue: newValue
        });
      }
    }
  }, {
    key: "_onRemoveIndex",
    value: function _onRemoveIndex(index, oldValue) {
      if (this.events.isEnabled("removeIndex")) {
        this.events.dispatch("removeIndex", {
          type: "removeIndex",
          target: this,
          index: index,
          oldValue: oldValue
        });
      }
    }
  }, {
    key: "_onMoveIndex",
    value: function _onMoveIndex(oldIndex, newIndex, value) {
      if (this.events.isEnabled("moveIndex")) {
        this.events.dispatch("moveIndex", {
          type: "moveIndex",
          target: this,
          oldIndex: oldIndex,
          newIndex: newIndex,
          value: value
        });
      }
    }
  }, {
    key: "_onClear",
    value: function _onClear(oldValues) {
      if (this.events.isEnabled("clear")) {
        this.events.dispatch("clear", {
          type: "clear",
          target: this,
          oldValues: oldValues
        });
      }
    }
    /**
     * Sets value at specific index.
     *
     * If there's already a value at the index, it is overwritten.
     *
     * @param index  Index
     * @param value  New value
     * @return New value
     */
  }, {
    key: "setIndex",
    value: function setIndex(index, value) {
      checkBounds(index, this._values.length);
      var oldValue = this._values[index];
      // Do nothing if the old value and the new value are the same
      if (oldValue !== value) {
        this._values[index] = value;
        this._onSetIndex(index, oldValue, value);
      }
      return oldValue;
    }
    /**
     * Adds an item to the list at a specific index, which pushes all the other
     * items further down the list.
     *
     * @param index Index
     * @param item  An item to add
     */
  }, {
    key: "insertIndex",
    value: function insertIndex(index, value) {
      checkBounds(index, this._values.length + 1);
      $array.insertIndex(this._values, index, value);
      this._onInsertIndex(index, value);
      return value;
    }
    /**
     * Swaps indexes of two items in the list.
     *
     * @param a  Item 1
     * @param b  Item 2
     */
  }, {
    key: "swap",
    value: function swap(a, b) {
      var len = this._values.length;
      checkBounds(a, len);
      checkBounds(b, len);
      if (a !== b) {
        var value_a = this._values[a];
        var value_b = this._values[b];
        this._values[a] = value_b;
        this._onSetIndex(a, value_a, value_b);
        this._values[b] = value_a;
        this._onSetIndex(b, value_b, value_a);
      }
    }
    /**
     * Removes a value at specific index.
     *
     * @param index  Index of value to remove
     * @return Removed value
     */
  }, {
    key: "removeIndex",
    value: function removeIndex(index) {
      checkBounds(index, this._values.length);
      var oldValue = this._values[index];
      $array.removeIndex(this._values, index);
      this._onRemoveIndex(index, oldValue);
      return oldValue;
    }
    /**
     * Moves an item to a specific index within the list.
     *
     * If the index is not specified it will move the item to the end of the
     * list.
     *
     * @param value  Item to move
     * @param index  Index to place item at
     */
  }, {
    key: "moveValue",
    value: function moveValue(value, toIndex) {
      // TODO don't do anything if the desired index is the same as the current index
      var index = this.indexOf(value);
      // TODO remove all old values rather than only the first ?
      if (index !== -1) {
        $array.removeIndex(this._values, index);
        if (toIndex == null) {
          var _toIndex = this._values.length;
          this._values.push(value);
          this._onMoveIndex(index, _toIndex, value);
        } else {
          $array.insertIndex(this._values, toIndex, value);
          this._onMoveIndex(index, toIndex, value);
        }
      } else if (toIndex == null) {
        this._values.push(value);
        this._onPush(value);
      } else {
        $array.insertIndex(this._values, toIndex, value);
        this._onInsertIndex(toIndex, value);
      }
      return value;
    }
    /**
     * Adds an item to the end of the list.
     *
     * @param item  An item to add
     */
  }, {
    key: "push",
    value: function push(value) {
      this._values.push(value);
      this._onPush(value);
      return value;
    }
    /**
     * Adds an item as a first item in the list.
     *
     * @param item  An item to add
     */
  }, {
    key: "unshift",
    value: function unshift(value) {
      this.insertIndex(0, value);
      return value;
    }
    /**
     * Adds multiple items to the list.
     *
     * @param items  An Array of items to add
     */
  }, {
    key: "pushAll",
    value: function pushAll(values) {
      var _this = this;
      $array.each(values, function (value) {
        _this.push(value);
      });
    }
    /**
     * Copies and adds items from abother list.
     *
     * @param source  A list top copy items from
     */
  }, {
    key: "copyFrom",
    value: function copyFrom(source) {
      this.pushAll(source._values);
    }
    /**
     * Returns the last item from the list, and removes it.
     *
     * @return Item
     */
  }, {
    key: "pop",
    value: function pop() {
      var index = this._values.length - 1;
      return index < 0 ? undefined : this.removeIndex(this._values.length - 1);
    }
    /**
     * Returns the first item from the list, and removes it.
     *
     * @return Item
     */
  }, {
    key: "shift",
    value: function shift() {
      return this._values.length ? this.removeIndex(0) : undefined;
    }
    /**
     * Sets multiple items to the list.
     *
     * All current items are removed.
     *
     * @param newArray  New items
     */
  }, {
    key: "setAll",
    value: function setAll(newArray) {
      var _this2 = this;
      var old = this._values;
      this._values = [];
      this._onClear(old);
      $array.each(newArray, function (value) {
        _this2._values.push(value);
        _this2._onPush(value);
      });
    }
    /**
     * Removes all items from the list.
     */
  }, {
    key: "clear",
    value: function clear() {
      this.setAll([]);
    }
    /**
     * Returns an ES6 iterator for the list.
     */
  }, {
    key: _Symbol$iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime().mark(function value() {
      var length, i;
      return _regeneratorRuntime().wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            length = this._values.length;
            i = 0;
          case 2:
            if (!(i < length)) {
              _context.next = 8;
              break;
            }
            _context.next = 5;
            return this._values[i];
          case 5:
            ++i;
            _context.next = 2;
            break;
          case 8:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
    /**
     * Calls `f` for each element in the list.
     *
     * `f` should have at least one parameter defined which will get a current
     * item, with optional second argument - index.
     */
  }, {
    key: "each",
    value: function each(f) {
      $array.each(this._values, f);
    }
    /**
     * Calls `f` for each element in the list, from right to left.
     *
     * `f` should have at least one parameter defined which will get a current
     * item, with optional second argument - index.
     */
  }, {
    key: "eachReverse",
    value: function eachReverse(f) {
      $array.eachReverse(this._values, f);
    }
  }]);
  return List;
}(Symbol.iterator);
/**
 * A version of a [[List]] where the elements are disposed automatically when
 * removed from the list, unless `autoDispose` is set to `false`.
 */
export var ListAutoDispose = /*#__PURE__*/function (_List) {
  _inherits(ListAutoDispose, _List);
  var _super = _createSuper(ListAutoDispose);
  function ListAutoDispose() {
    var _this3;
    _classCallCheck(this, ListAutoDispose);
    _this3 = _super.apply(this, arguments);
    /**
     * Automatically disposes elements that are removed from the list.
     *
     * @default true
     */
    Object.defineProperty(_assertThisInitialized(_this3), "autoDispose", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    return _this3;
  }
  _createClass(ListAutoDispose, [{
    key: "_onSetIndex",
    value: function _onSetIndex(index, oldValue, newValue) {
      if (this.autoDispose) {
        oldValue.dispose();
      }
      _get(_getPrototypeOf(ListAutoDispose.prototype), "_onSetIndex", this).call(this, index, oldValue, newValue);
    }
  }, {
    key: "_onRemoveIndex",
    value: function _onRemoveIndex(index, oldValue) {
      if (this.autoDispose) {
        oldValue.dispose();
      }
      _get(_getPrototypeOf(ListAutoDispose.prototype), "_onRemoveIndex", this).call(this, index, oldValue);
    }
  }, {
    key: "_onClear",
    value: function _onClear(oldValues) {
      if (this.autoDispose) {
        $array.each(oldValues, function (x) {
          x.dispose();
        });
      }
      _get(_getPrototypeOf(ListAutoDispose.prototype), "_onClear", this).call(this, oldValues);
    }
  }, {
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        if (this.autoDispose) {
          $array.each(this._values, function (x) {
            x.dispose();
          });
        }
      }
    }
  }]);
  return ListAutoDispose;
}(List);
/**
 * A version of a [[List]] that is able to create new elements as well as
 * apply additional settings to newly created items.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/list-templates/} for more info
 */
export var ListTemplate = /*#__PURE__*/function (_ListAutoDispose) {
  _inherits(ListTemplate, _ListAutoDispose);
  var _super2 = _createSuper(ListTemplate);
  function ListTemplate(template, make) {
    var _this4;
    _classCallCheck(this, ListTemplate);
    _this4 = _super2.call(this);
    Object.defineProperty(_assertThisInitialized(_this4), "template", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this4), "make", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _this4.template = template;
    _this4.make = make;
    return _this4;
  }
  return _createClass(ListTemplate);
}(ListAutoDispose);